module.exports = __webpack_public_path__ + "img/13.562909e6.svg";